// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const V2HttpEndpointResponseBody = {
    error: (value) => {
        return {
            value: value,
            type: "error",
            _visit: function (visitor) {
                return FernIr.V2HttpEndpointResponseBody._visit(this, visitor);
            },
        };
    },
    json: (value) => {
        return {
            value: value,
            type: "json",
            _visit: function (visitor) {
                return FernIr.V2HttpEndpointResponseBody._visit(this, visitor);
            },
        };
    },
    stream: (value) => {
        return {
            value: value,
            type: "stream",
            _visit: function (visitor) {
                return FernIr.V2HttpEndpointResponseBody._visit(this, visitor);
            },
        };
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "error":
                return visitor.error(value.value);
            case "json":
                return visitor.json(value.value);
            case "stream":
                return visitor.stream(value.value);
            default:
                return visitor._other(value);
        }
    },
};
